import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import CustomerDashboard from "../../components/CustomerDashboard/CustomerDashboard";
import Langtrans from "../../components/Langtrans/Langtrans";
import Container from "../../Container/Container";
import Buttons from "../../components/Button/Button";
import shirt from "../../assets/Gildan 64000 blanc (front) (transparent)(fond blanc).png";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import tshirt from "../../assets/t-shirt-icon.png";
import Chart from "react-apexcharts";
import money from "../../assets/money.png";
import clock from "../../assets/clock.png";
import "./Dashboard.scss";
import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { productData, draftId } from "../../store/action";
const CompaignDraft = (props) => {
	const draftData = props.location.state;
	const { t } = useTranslation();
	const history = useHistory();
	const dispatch = useDispatch();
	const [shirtsdata1, setshirtdata1] = useState("");
	const [shirtsdata2, setshirtdata2] = useState("");
	const [shirtsdata3, setshirtdata3] = useState("");
	const [shirtsdata4, setshirtdata4] = useState("");
	const [loader, setLoader] = useState(false);
	const [options, setOptions] = useState({
		chart: {
			id: "basic-bar",
		},
		xaxis: {
			categories: [],
		},
	});
	const [series, setSeries] = useState([
		{
			name: "series-1",
			data: [],
		},
	]);

	function toDataURL(url, callback) {
		var xhr = new XMLHttpRequest();
		xhr.onload = function () {
			var reader = new FileReader();
			reader.onloadend = function () {
				callback(reader.result);
			};
			reader.readAsDataURL(xhr.response);
		};
		url += "?" + new Date().getTime();
		xhr.open("GET", url);
		xhr.responseType = "blob";
		xhr.send();
	}
	const handleRoute = () => {
		setLoader(true);
		selShirt();
	};
	const selShirt = async (data) => {
		setLoader(true);
		await toDataURL(draftData.frontImg, async function (myBase64) {
			setshirtdata1(
				myBase64.replace(
					"data:binary/octet-stream;base64,",
					"data:image/png;base64,",
				),
			);
		});
		await toDataURL(draftData.backImg, async function (myBase64) {
			setshirtdata2(
				myBase64.replace(
					"data:binary/octet-stream;base64,",
					"data:image/png;base64,",
				),
			);
		});
		await toDataURL(draftData.shirtDesignFront, async function (myBase64) {
			setshirtdata3(
				myBase64 &&
					myBase64.replace(
						"data:binary/octet-stream;base64,",
						"data:image/png;base64,",
					),
			);
		});
		await toDataURL(draftData.shirtDesignBack, async function (myBase64) {
			setshirtdata4(
				myBase64 &&
					myBase64.replace(
						"data:binary/octet-stream;base64,",
						"data:image/png;base64,",
					),
			);
		});
	};

	useEffect(() => {
		if (shirtsdata1 && shirtsdata2 && shirtsdata3 && shirtsdata4) {
			dispatch(
				productData({
					shirt: {
						cost: draftData.realprice,
						frontImg: shirtsdata1,
						backImg: shirtsdata2,
						color: draftData.color,
						frontshirturl: draftData.shirtDesignBack,
						backshirturl: draftData.shirtDesignFront,
						category: draftData.shirtCategory,
						garmentName: draftData.shirtrealName,
					},
					inProgress: true,
					target: draftData.target,
					color: draftData.shirtColor,
					brief: draftData.brief,
					day: draftData.days,
					detail: draftData.detail,
					price: draftData.sellingPrice,
					shirtname: draftData.shirtName,
					shirtdesign:
						shirtsdata3 && shirtsdata3 !== "data:"
							? [{ preview: shirtsdata3 }]
							: [],
					designnimg: draftData.designShirt,
					designnimgback: draftData.designShirtBack,
					realprice: draftData.realprice,
					campaign: draftData.noOfCampaigns,
					shirtdesignback:
						shirtsdata4 && shirtsdata4 !== "data:"
							? [{ preview: shirtsdata4 }]
							: [],
					frontDesignObj: {
						width: draftData.frontDesign.width,
						height: draftData.frontDesign.height,
						x: draftData.frontDesign.x,
						y: draftData.frontDesign.y,
					},
					backDesignObj: {
						width: draftData.backDesign.width,
						height: draftData.backDesign.height,
						x: draftData.backDesign.x,
						y: draftData.backDesign.y,
					},
					step: draftData.step,
				}),
			);
			dispatch(
				draftId({
					draftProductId: draftData.id,
				}),
			);
			history.push({
				pathname:
					draftData.step === 2
						? "/setprice"
						: draftData.step === 3
						? "/describecampaign"
						: draftData.step === 4
						? "/preview"
						: null,
			});
			setTimeout(() => {
				setshirtdata1("");
				setshirtdata2("");
				setshirtdata3("");
				setshirtdata4("");
			}, 3000);
			setLoader(false);
		}
	}, [shirtsdata1 && shirtsdata2 && shirtsdata3 && shirtsdata4]);

	return (
		<>
			<div className="home">
				<div className="left">
					<CustomerDashboard />
				</div>
				<div className="right">
					<div className="top" style={{ marginTop: "10px" }}>
						<div className="page-heading">
							<h3 onClick={() => history.goBack()} className="cp">
								&#60; {t("refine")}
							</h3>
							<div
								style={{
									display: "flex",
									color: "#b3b3b3",
								}}
							>
								<span>
									<OpenInNewIcon />
								</span>
								<span>{t("countryside")}</span>
							</div>
							<Buttons
								style={{
									background: "#888888",
									padding: "3px",
									marginTop: "10px",
									marginLeft: "1px",
								}}
								text={t("draft")}
							/>
						</div>
						<div style={{ marginLeft: "-100px" }}>
							<img src={draftData?.designShirt} width={170} height={150} />
						</div>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								marginTop: "-80px",
							}}
						>
							<div>
								<div style={{ display: "flex", alignItems: "center" }}>
									<Buttons
										style={{
											width: "180px",
											marginLeft: "3px",
											background: "#05155e",
											marginRight: "10px",
										}}
										text={t("modify_campaign")}
										onClick={() => handleRoute()}
										loader={loader}
									/>
									<Langtrans
										dashboard
										style={{
											marginRight: "0px",
											marginTop: "0px",
											height: "36px",
										}}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="bottom">
						<hr />
						<div className="bottom-top">
							<div
								className="card"
								style={{ height: "210px", paddingTop: "20px" }}
							>
								<div className="cal-div">
									<div style={{ display: "flex", alignItems: "center" }}>
										{/* <div>
											<h2>{t("no-camp-lacnched")}</h2>
											<p style={{ textAlign: "center" }}>
												<b>{t("first-sale")}</b>
											</p>
											<Buttons
												text={`> ${t("launch_campaign")}`}
												className="campaign-btn btn"
											/>
										</div> */}
									</div>
									<div className="shirt-div">
										<img src={tshirt} width={50} height={50} />
										<h2>-</h2>
										<p>
											<b>{t("pre-order")}</b>
										</p>
										<small>{t("need-preorders")}</small>
									</div>
									<div className="shirt-div">
										<img src={money} width={50} height={50} />
										<h2>-</h2>
										<p>
											<b>{t("potential")}</b>
										</p>
										<small>{t("need-preorders")}</small>
									</div>
									<div className="shirt-div">
										<img src={clock} width={50} height={50} />
										<h2>-</h2>
										<p>
											<b>{t("remains-day")}</b>
										</p>
										<small>{t("delivery")}</small>
									</div>
								</div>
							</div>
						</div>
						<div className="chart">
							<h2>{t("per-day-order")}</h2>
							<Chart
								options={options}
								series={series}
								type="line"
								width="100%"
								height="500px"
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
export default CompaignDraft;
